export class AuthenticationModel {

    /**
     *  ä½¿ç¨èç»å¥æ¬æ
     */
    token : string
}
